export const environment = {
  production: false,
  // Resolve API and SignalR requests against the host serving Classic. This
  // keeps the same build portable across FS3, Development, and Staging and
  // ensures every environment uses its co-deployed backend.
  ENDPOINT: "",
  CODEC_CONFIG_URL: "/assets/codecConfig/config.json",
  AUTH_TOKEN:
    '',
};
